<template>
<div class="flex-body body-scroll">
    <div class="container-fluid">
        <div class="container-centered-s py-4">
            <h5 class="mb-2">Client Setup</h5>

            <h3>Services</h3>

            <div>
                <form class="mui-form py-1" @submit.prevent="onSubmit()" style="min-height: 20em;">
                    <form-errors :errors="formErrors"/>

                    <div class="form-row pb-2">
                        <div class="col">
                            <form-input label="ESS" type="checkbox" v-model="formData.has_ess" :errors="errors.has_ess" />
                        </div>
                    </div>
                    <div class="form-row pb-2">
                        <div class="col">
                            <form-input label="Enhanced ESS" type="checkbox" v-model="formData.has_enhanced_ess" :errors="errors.has_enhanced_ess" />
                        </div>
                    </div>
                    <div class="form-row pb-2">
                        <div class="col">
                            <form-input label="Paperless Onboarding" type="checkbox" v-model="formData.has_paperless_onboarding" :errors="errors.has_paperless_onboarding" />
                        </div>
                    </div>
                    <div class="form-row pb-2">
                        <div class="col">
                            <form-input label="Company Docs Module" type="checkbox" v-model="formData.has_company_docs_module" :errors="errors.has_company_docs_module" />
                        </div>
                    </div>
                    <div class="form-row pb-2">
                        <div class="col">
                            <form-input label="Custom Forms Module" type="checkbox" v-model="formData.has_custom_forms_module" :errors="errors.has_custom_forms_module" />
                        </div>
                    </div>
                    <div class="form-row pb-2">
                        <div class="col">
                            <form-input label="Uniform Module" type="checkbox" v-model="formData.has_uniform_module" :errors="errors.has_uniform_module" />
                        </div>
                    </div>
                    <div class="form-row pb-2">
                        <div class="col">
                            <form-input label="Ad Hoc Docs Module" type="checkbox" v-model="formData.has_ad_hoc_docs_module" :errors="errors.has_ad_hoc_docs_module" />
                        </div>
                    </div>

                    <div class="row mb-2 mt-2 d-flex align-items-center">
                        <div class="col"></div>

                        <div class="col text-right">
                            <button class="btn btn-primary" @click.prevent="onSubmit">Save</button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>
</template>


<script>
import FormMixin from '@/mixins/Form'

export default {
    props: ['client'],
    mixins: [FormMixin],
    components: {},
    data() {
        return {
            formData: this.makeFormData(),
            errors: {},
            formErrors: [],
        }
    },
    mounted() {
        this.$store.dispatch('SET_PAGE_TITLE', 'Settings / Services')
    },
    methods: {
        makeFormData() {
            let client = JSON.parse(JSON.stringify(this.client))
            return {
                'has_ess': client.has_ess,
                'has_enhanced_ess': client.has_enhanced_ess,
                'has_paperless_onboarding': client.has_paperless_onboarding,
                'has_company_docs_module': client.has_company_docs_module,
                'has_custom_forms_module': client.has_custom_forms_module,
                'has_uniform_module': client.has_uniform_module,
                'has_ad_hoc_docs_module': client.has_ad_hoc_docs_module
            }
        },
        getFormData() {
            return this.formData
        },
        onSubmit() {
            this.$store.dispatch('START_LOADING')
            return this.$api.post(`/clients/${this.client.id}/settings/services`, this.getFormData()).then(resp => {
                this.$store.dispatch('STOP_LOADING')
                this.$emit('updated')
            }).catch((errors) => {
                console.log(errors)
                this.$store.dispatch('STOP_LOADING')

                this.formErrors = (errors.__all__ || [])
                this.$bus.showError('Please check the form for any missing fields.')
            })
        },
    },
}
</script>
